import { useMemo } from 'react';

import { IconAlignLeft } from 'src/assets/icons/IconAlignLeft';
import { IconZap } from 'src/assets/icons/IconZap';
import { CUSTOM_MENU_ITEM_TYPE } from 'src/components/CustomMenuItem';
import { useBrandBriefsMenuItems } from 'src/services';

import { IMPORT_BRIEF_SOURCE } from '../const';

export const useImportBriefMenuItems = ({
  onSelect,
  brandVoicesAssets,
  loadingBrandVoiceAssets,
  displayBrandBriefs,
  onEditBrief,
}) => {
  const brandBriefsItems = useBrandBriefsMenuItems({
    brandVoicesAssets,
    isLoading: loadingBrandVoiceAssets,
    onSelect,
    onEditBrief,
  });

  return useMemo(() => {
    const result = [
      {
        id: IMPORT_BRIEF_SOURCE.fromUrl,
        type: CUSTOM_MENU_ITEM_TYPE.default,
        label: 'Get text from website',
        icon: <IconZap />,
        onClick: () => onSelect(IMPORT_BRIEF_SOURCE.fromUrl),
      },
    ];

    if (displayBrandBriefs) {
      result.push({
        id: IMPORT_BRIEF_SOURCE.brandBrief,
        type: CUSTOM_MENU_ITEM_TYPE.submenu,
        label: 'Use messaging bank',
        icon: <IconAlignLeft />,
        items: brandBriefsItems,
      });
    }

    return result;
  }, [displayBrandBriefs, onSelect, brandBriefsItems]);
};
